var jxapis = {
  "全民解析":"https://jx.aidouer.net/?url=",
  "go": "https://jx.playerjy.com?url=",
  "8090g": "https://www.8090g.cn/?url=",
  "8090g2": "https://www.8090g.cn/jiexi/?url=",
  "ckmov": "https://www.ckmov.vip/api.php?url=",
  "m3u8": "https://jx.m3u8.tv/jiexi/?url=",
  "当前可直接搜索电影/电视剧/综艺等名称,如需解析其他的链接请手动切换解析源" : "https://z1.m1907.top/?jx=",
}

export default jxapis;
